import { LoadingComponent } from "./LoadingComponent";

export const AuthenticatingComponent = () => {
  console.log(
    "Authenticating component. User being redirected towards authentication page."
  );

  return <LoadingComponent />;
};
